import clsx from 'clsx'
import { observer } from 'mobx-react'
import { generatePath, NavLink, useParams } from 'react-router-dom'
import SimpleBar from 'simplebar-react'

import { routeName } from '~/@common/constants'
import Badge from '~/@common/ui/Badge/Badge'
import { Icon } from '~/@common/ui/Icon/Icon'

import type { LectureGroup as LectureGroupT } from '../@service/Lecture.service'
import { S } from './LectureGroup.style'

const LectureGroup = ({ lectureGroup }: { lectureGroup: LectureGroupT }) => {
  const params = useParams<{ lectureId: string }>()

  return (
    <div css={S.LectureGroup}>
      <header>{lectureGroup.leadingCurriculum.name}</header>
      <ul className="lecture-group-item-list">
        <SimpleBar style={{ maxHeight: '100%' }}>
          {lectureGroup.middleChapterLectures.map((middleChapterLecture) => (
            <NavLink
              key={middleChapterLecture.id}
              to={generatePath(routeName.student.lectureDetail, {
                lectureId: middleChapterLecture.id,
              })}
              replace={'lectureId' in params}
              className={({ isActive }) => clsx('lecture-group-item', isActive && 'is-active')}
            >
              <div css={S.LectureGroupItem}>
                <Badge theme="primaryBlue" className="active-badge">
                  <Icon name="icon_play_circle" size={12} color="var(--White)" />
                  시청중
                </Badge>
                <span className="lecture-title">{middleChapterLecture.title}</span>
              </div>
            </NavLink>
          ))}
        </SimpleBar>
      </ul>
    </div>
  )
}

export default observer(LectureGroup)
